import  { useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import useDialog from "../../../hooks/useDialog";
import { Grid, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AutocompleteField from "../../field/AutocompleteField";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import UserDetailsDialog from "../../dialog/UserDetailsDialog";
import TenantDetailsDialog from "../../dialog/TenantDetailsDialog";
import BaseBox from "../../base/BaseBox/baseBox";
import FieldWithLabel from "../../field/FieldWithLabel";
import DateTimeField from "../../field/DateTimeField";

const TaskLeftForm = (props) => {
  const { t } = useTranslation();

  const [
    openUserDetailsDialog,
    onOpenUserDetailsDialog,
    onCloseUserDetailsDialog,
  ] = useDialog();

  const [
    openTenantDetailsDialog,
    onOpenTenantDetailsDialog,
    onCloseTenantDetailsDialog,
  ] = useDialog();

  const selectedUserId = useRef();
  const userDetailsDialogTitle = useRef();
  const handleOpenUserDetailsDialog = (userId, title) => {
    selectedUserId.current = userId;
    userDetailsDialogTitle.current = title;

    onOpenUserDetailsDialog();
  };

  return (
    <BaseBox>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <Typography
            variant="h6"
            className="capitalize-first-letter"
            color={"primary"}
          >
            {t("form.ticket_order_details_form.details")}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.ticket_order_details_form.ticket_owner")}
            field={
              <TextFieldFormControl
                value={props.formValue.ticket_owner?.full_name}
                suffix={
                  props.formValue.ticket_owner?.id ? (
                    <PersonIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleOpenUserDetailsDialog(
                          props.formValue.ticket_owner.id,
                          "applicant"
                        )
                      }
                    />
                  ) : null
                }
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.ticket_order_details_form.ticket_om")}
            field={
              <TextFieldFormControl
                value={props.formValue.ticket_om?.full_name}
                suffix={
                  props.formValue.ticket_om?.id ? (
                    <PersonIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleOpenUserDetailsDialog(
                          props.formValue.ticket_om.id,
                          "ticket_om"
                        )
                      }
                    />
                  ) : null
                }
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.ticket_order_details_form.tenant")}
            field={
              <TextFieldFormControl
                value={props.formValue.tenant?.tenant_short_name}
                suffix={
                  props.formValue.tenant?.id ? (
                    <PersonIcon
                      style={{ cursor: "pointer" }}
                      onClick={onOpenTenantDetailsDialog}
                    />
                  ) : null
                }
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.ticket_order_details_form.responsilbe_person")}
            field={
              <AutocompleteField
                name={"order_kt"}
                value={props.formValue.task_kt}
                options={props.filteringData.task_kt}
                isObjectOption={true}
                optionLabelKey={"full_name"}
                readOnly
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.task_t")}
            field={
              <AutocompleteField
                name={"order_t"}
                value={props.formValue.task_t}
                options={props.filteringData.task_t}
                isObjectOption={true}
                optionLabelKey={"full_name"}
                readOnly
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.skill")}
            field={
              <AutocompleteField
                name={"skill"}
                value={props.formValue.skill}
                options={props.filteringData.skill}
                isObjectOption={true}
                optionLabelKey={"skill_name"}
                readOnly
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.task_date_startT_plan")}
            field={
              <DateTimeField
                name="task_date_startT_plan"
                value={props.formValue.task_date_startT_plan}
                showClearIcon={false}
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.task_date_stopT_plan")}
            field={
              <DateTimeField
                name="task_date_stopT_plan"
                value={props.formValue.task_date_stopT_plan}
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.task_date_startT_real")}
            field={
              <DateTimeField
                name="task_date_startT_real"
                value={props.formValue.task_date_startT_real}
                readOnly
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FieldWithLabel
            label={t("form.task.task_date_stopT_real")}
            field={
              <DateTimeField
                name="task_date_stopT_real"
                value={props.formValue.task_date_stopT_real}
                readOnly
              />
            }
          />
        </Grid>

        {openUserDetailsDialog && (
          <UserDetailsDialog
            open={openUserDetailsDialog}
            onClose={onCloseUserDetailsDialog}
            userId={selectedUserId.current}
            title={userDetailsDialogTitle.current}
          />
        )}
        {openTenantDetailsDialog && (
          <TenantDetailsDialog
            open={openTenantDetailsDialog}
            onClose={onCloseTenantDetailsDialog}
            tenantId={props.formValue.tenant?.id}
          />
        )}
      </Grid>
    </BaseBox>
  );
};

TaskLeftForm.propTypes = {
  formValue: PropTypes.object,
  filteringData: PropTypes.object,
  onChange: PropTypes.func,
  onChangeDate: PropTypes.func,
  onChangeAutocompleteFieldWithObjectOptions: PropTypes.func,
  itemType: PropTypes.oneOf(["ticket", "order"]),
  readOnly: PropTypes.bool,
  isTicketClaim: PropTypes.bool,
  isOM: PropTypes.bool,
};

TaskLeftForm.defaultProps = {
  readOnly: false,
};

export default TaskLeftForm;
